module.exports = __webpack_public_path__ + "img/icon(10).1b4649ac.png";